import { merge } from '@inpart-io/devtools';
import { type IUserProfile } from '@inpart-io/devtools-iap';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { userProfilesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IUserState } from './types';

const USER_PROFILE_MODULE = 'userProfile';

const state: IUserState = {
    byUser: new Map(),
    all: []
};

const dataObjectModule = getDataObjectsModule<IUserProfile>(userProfilesManager);
const userProfileModuleInstance = merge<unknown>(dataObjectModule, { state, actions, getters, mutations });
store.registerModule(USER_PROFILE_MODULE, userProfileModuleInstance);

export { USER_PROFILE_MODULE };
